import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { ConfigService } from 'src/app/shared/services';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl: string;
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiUrl = this.configService.getConfig()['apiURL'];
    
    // Initialize with user from localStorage if available
    const storedUser = this.getUserFromStorage();
    this.currentUserSubject = new BehaviorSubject<any>(storedUser);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  registerUser(userData: any): Observable<any> {
    const payload = {
      name: userData.name,
      email: userData.email,
      employeeNumber: userData.employeeNumber,
      password: userData.password,
      role: userData.role.code
    };
    return this.http.post(`${this.apiUrl}quotation-users`, payload);
  }

  login(employeeNumber: string, password: string): Observable<any> {
    const payload = { employeeNumber, password };
    return this.http.post(`${this.apiUrl}quotation-users/login`, payload);
  }

  forgotPassword(employeeNumber: string): Observable<any> {
    return this.http.post(`${this.apiUrl}quotation-users/forgot-password`, { employeeNumber });
  }

  resetPassword(employeeNumber: string, otp: string, newPassword: string): Observable<any> {
    return this.http.post(`${this.apiUrl}quotation-users/reset-password`, {
      employeeNumber,
      otp,
      newPassword
    });
  }
  setCurrentUser(user: any): void {
    this.currentUserSubject.next(user);
    if (user) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    } else {
      localStorage.removeItem('currentUser');
    }
  }

  getCurrentUser(): any {
    return this.currentUserSubject.value;
  }

  private getUserFromStorage(): any {
    try {
      const storedUser = localStorage.getItem('currentUser');
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      localStorage.removeItem('currentUser');
      return null;
    }
  }

  // Check if user is authenticated
  isAuthenticated(): boolean {
    const currentUser = this.getCurrentUser();
    return currentUser !== null && currentUser !== undefined;
  }

  // Clear user data on logout
  logout(): void {
    this.currentUserSubject.next(null);
    localStorage.removeItem('currentUser');
    // You might also want to clear other related data
    localStorage.removeItem('rememberedEmployee');
  }
    verifyPassword(employeeNumber: string, password: string): Observable<boolean> {
    return this.http.post(`${this.apiUrl}quotation-users/login`, { employeeNumber, password }).pipe(
      map(() => true),          // 200 response → password is correct
      catchError(() => of(false)) // 401/403/any error → password is wrong
    );
  }
}
